import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentContainerGrid: {
    width: "auto",
    margin: "0 auto",
    marginTop: -6,

    [theme.breakpoints.up("sm")]: {
      maxWidth: "53.75rem",
    },
  },

  title: {
    fontFamily: "var(--font-family-1)",
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "28px",
    textAlign: "left",
    color: "#677aa7",
    marginBottom: 26,
  },

  paragraph: {
    fontFamily: "var(--font-family-3)",
    fontWeight: "normal",
    fontSize: 16,
    lineHeight: "22px",
    textAlign: "left",
    color: "#a6b5d9",
    marginBottom: 47,
  },

  list: {
    padding: 0,
    paddingLeft: 15,
    margin: 0,
    marginBottom: 47,
  },

  listItem: {
    fontFamily: "var(--font-family-3)",
    fontWeight: "normal",
    fontSize: 16,
    lineHeight: "22px",
    textAlign: "left",
    color: "#a6b5d9",

    "&:not(:last-of-type)": {
      marginBottom: 24,
    },
  },
}));

export default useStyles;
